import PropTypes from 'prop-types'

import virtualListPropType from '../../virtual-list/virtual-list-prop-type'
import { idAndNameArrayPropType } from './id-and-name-array-prop-type'
import { idPropType } from './id-prop-type'

/**
 * Proptype that represents an item source and holds an array of items
 * @typedef {Object}                         itemSourcePropType
 * @param   {idPropType}                     id                     - id of the source
 * @param   {string}                         [filterPlaceholder]    - placeholder of the filter box
 * @param   {string}                         [placeholder]          - placeholder to show while no item is selected
 * @param   {Object}                         [icon]                 - an element to be used as icon for this source
 * @param   {Array.<idAndNameArrayPropType>} [items]                - items array (id + name)
 * @param   {VirtualList}                    [virtual]              - settings for creating virtual list of data source
 */
export const itemSourcePropType = PropTypes.shape({
    filterPlaceholder: PropTypes.string,
    icon: PropTypes.element,
    id: idPropType.isRequired,
    items: idAndNameArrayPropType,
    placeholder: PropTypes.string,
    virtual: virtualListPropType
})
